import clsx from "clsx";
import { Fragment } from "react";
import { HeroTitle, TextBadge } from "components/atoms/Text";
import { PrimaryButton, SurfaceButton } from "components/atoms/Button";

const Hero = () => {
    return (
        <Fragment>
            <header className={clsx(
                "w-full max-w-[1440px] mx-auto",
                "flex flex-col tablet:flex-row desktop:flex-row justify-between",
                "px-6 tablet:px-8 desktop:pl-[120px] desktop:pr-[94px] phone:pb-12 tablet:pb-[48px] pb-[88px]",
            )}>
                <div className="w-full tablet:max-w-[457px] desktop:max-w-[550px] mt-[69px] phone:mt-8 tablet:mt-[50px]">
                    <TextBadge>Shared Proxy</TextBadge>
                    <HeroTitle classNames="tablet:!text-[48px] tablet:!leading-[64.8px]">Shared HTTP Proxies</HeroTitle>
                    <p className="max-w-[432px] pt-4 tablet:max-w-[430px] font-normal relative z-30 phone:text-md text-neutral-50 text-md tracking-text !leading-[27.2px]">As part of our stack we also offer shared proxies at lower prices. Most of our shared proxies are close to the dedicated ones in quality because we don't "crowd" the IP addresses with too many clients.</p>
                    <div className="w-full flex flex-col md:flex-row md:items-center md:space-x-6 space-y-4 md:space-y-0 mt-8 tablet:mt-8 phone:mt-8">
                        <PrimaryButton>Get Started</PrimaryButton>
                        <SurfaceButton>See Pricing</SurfaceButton>
                    </div>
                </div>
                <div className="w-full tablet:max-w-[471px] max-w-[543px] mt-8 phone:mt-10 tablet:mt-6">
                    <img src="/images/proxy/shared.svg" className="w-[543px] h-[494px] phone:h-[298px] tablet:w-[471px] tablet:h-[429px]" alt="proxy-hero" />
                </div>
            </header>
        </Fragment>
    );
};

export default Hero;